import Vue from 'vue'
import Vuex from 'vuex'
import { getToken } from '../utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 初始值直接跟随持久化存储，刷新后 URL 与状态一致
    token: getToken(),
    userInfo: null
  },
  mutations: {
    setToken(state, payload) {
      state.token = payload
    },
    setUserInfo(state, payload) {
      state.userInfo = payload
    },
    clearUser(state) {
      state.token = ''
      state.userInfo = null
    }
  },
  actions: {
  },
  modules: {
  }
})
